import { useContext } from 'react';

import { I18nContext } from './context';

import type { I18nContextValue, Translate } from './types';

function useI18n(): I18nContextValue {
    const context = useContext(I18nContext);
    if (context === null) throw new Error('I18nProvider is missing');
    return context;
}

export function useLocale(): Pick<
    I18nContextValue,
    'locale' | 'localePreference' | 'setLocalePreference'
> {
    const { locale, localePreference, setLocalePreference } = useI18n();
    return { locale, localePreference, setLocalePreference };
}

export function useTranslate(): Translate {
    return useI18n().translate;
}
